<template>
    <slick :options="options" class="Carousel">
        <slot></slot>
    </slick>
</template>

<script>
    import Slick from 'vue-slick';
    export default {
        components: {
            slick: Slick
        },

        props: {
            arrows: {
                type: Boolean,
                default: true
            },
            autoplay: {
                default: 5000
            }
        },

        data() {
            return {
                options: {
                    infinite: true,
                    autoplay: this.autoplay ? true : false,
                    autoplaySpeed: this.autoplay,
                    arrows: this.arrows,
                }
            }
        }
    }
</script>
